// extracted by mini-css-extract-plugin
export default {"icon":"ModalComponent_icon__yIveL","divText":"ModalComponent_divText__HsZVM","button":"ModalComponent_button__PLV-k","modalFooter":"ModalComponent_modalFooter__kMLc+"};